import { textFormatting } from '@yola/ws-sdk';
import removeDynamicAttributes from './remove-dynamic-attributes';

const { removeRelatedClassesFromElement } = textFormatting.helpers;

const prepareSelectedContent = (selection) => {
  const container = document.createElement('div');

  container.innerHTML = selection.toHtml();

  removeDynamicAttributes(container);
  removeRelatedClassesFromElement(container);

  return container.innerHTML;
};

export default prepareSelectedContent;
